/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overview_header__nav-link[_ngcontent-%COMP%]{cursor:pointer;color:#00a3e0;text-decoration:none}.overview__subheader[_ngcontent-%COMP%]   .suggest-a-change[_ngcontent-%COMP%]{margin-top:5px}"];
export { styles as styles };
